export const downloadFile = (blobOrResponse, filename = "download") => {
  let blob;
  let finalFilename = filename;

  try {
    if (blobOrResponse instanceof Blob) {
      blob = blobOrResponse;
    } else if (blobOrResponse?.data) {
      if (blobOrResponse?.status !== 200) {
        throw new Error("Failed to download file");
      }
      blob = blobOrResponse.data;
      const contentDisposition = blobOrResponse.headers["content-disposition"];
      if (contentDisposition) {
        const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;\s]+)/i);
        if (utf8Match) {
          finalFilename = decodeURIComponent(utf8Match[1]);
        } else {
          const quotedMatch = contentDisposition.match(/filename="([^"]+)"/i);
          if (quotedMatch) {
            finalFilename = quotedMatch[1];
          } else {
            const plainMatch = contentDisposition.match(/filename=([^;\s]+)/i);
            if (plainMatch) {
              finalFilename = plainMatch[1];
            }
          }
        }
      }
    } else {
      throw new Error("Invalid input for download");
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = finalFilename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("An error occurred while downloading file: ", error);
  }
};

export const downloadCSVFile = (response, defaultFilename = "export.csv") => {
  try {
    return downloadFile(response, defaultFilename);
  } catch (error) {
    console.error("An error occurred while downloading CSV file: ", error);
  }
};
